import { QueryClient } from "@tanstack/react-query";

/**
 * Server state lives here and only here (CLAUDE.md § Frontend): no copying query results into
 * component state. Defaults are deliberate rather than inherited — an accounting screen that
 * silently refetches while someone is reading a number is worse than a stale one they refresh.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });
}
